import type { ThemeWithoutTokens } from '../theme.types';

export const headerNavItemTokens = (theme: ThemeWithoutTokens) =>
  ({
    headerNavItemPaddingX: theme.space.component.x.s,
    // overlay
    headerNavItemOverlayRadius: theme.radiuses.l,
    headerNavItemOverlayPaddingY: theme.space.component.y.s,

    // anchor
    headerNavItemAnchorTextColor: theme.colors.body.text,
    headerNavItemAnchorActiveTextColor: theme.colors.primary.normal,

    // dropdown icon
    headerNavItemDropdownIconPaddingX: theme.space.component.x.xs,
    headerNavItemDropdownIconFontSize: theme.typography.fontSize.xs,
  }) as const;
